import {
  Backdrop,
  Body,
  CloseButton,
  CloseIcon,
  CostLabel,
  Column,
  Container,
  Content,
  Header,
  HeaderText,
  IconMotoboy,
  Line,
  LineSpace,
  ModalContainer,
  StyledModal,
  RowHistoric,
  DeliveryNumber,
  StatusContainer,
  IsEditedIcon,
  IsDeletedIcon,
  ClientContainer,
  InfoContainer,
  CustomerIcon,
  MotoboyIcon,
  Label,
  DescriptionContainer,
  DateContainer,
} from './styles';

import { IMotoboyDeliveries, IReceipts } from 'src/types';
import PaymentType from '../PaymentType';
import React from 'react';
import ReactDOM from 'react-dom';
import { isEmpty } from 'lodash';
import { dateTimeFormat } from 'src/utils/DateFormatter';
import { useTheme } from 'styled-components';
import { maskToPrice } from 'src/utils/InputMask';

interface Props {
  motoboyDeliveries: IMotoboyDeliveries;
  show: boolean;
  onDismiss(): void;
}

const MotoboyDeliveriesHistoricModal: React.FC<Props> = ({
  motoboyDeliveries,
  show,
  onDismiss,
}) => {
  const [editReceipt, setEditReceipt] = React.useState<IReceipts[]>({} as IReceipts[]);
  const { colors } = useTheme();

  React.useEffect(() => {
    setEditReceipt(motoboyDeliveries.receipts);
  }, [motoboyDeliveries.receipts]);

  React.useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const key = event.key || event.keyCode;
      if ((key === 27 || key === 'Escape') && show) {
        onDismiss();
      }
    };

    show
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'unset');

    document.addEventListener('keydown', onKeyDown, false);

    return () => {
      document.removeEventListener('keydown', onKeyDown, false);
    };
  }, [onDismiss, show]);

  const StatusIcon = (isEdited: boolean, isDeleted: boolean) => {
    const showIcon = isDeleted || isEdited;

    return (
      showIcon && (
        <StatusContainer color={isEdited ? colors.secondary : colors.textError}>
          {isEdited && !isDeleted && <IsEditedIcon />}
          {isDeleted && <IsDeletedIcon />}
        </StatusContainer>
      )
    );
  };

  const RowGenerate = ({
    isEdited,
    isDeleted,
    customer,
    motoboy,
    deliveryId,
    description,
    date,
    paymentType,
    cost,
  }: IReceipts) => (
    <RowHistoric>
      <Line>
        <DeliveryNumber color={isEdited || isDeleted ? colors.textLight : colors.primary}>
          {deliveryId}
          {StatusIcon(isEdited, isDeleted)}
        </DeliveryNumber>
        <ClientContainer>
          <InfoContainer>
            <CustomerIcon
              color={isEdited || isDeleted ? colors.textLight : colors.primary}
            />
            <Label color={isEdited || isDeleted ? colors.textLight : colors.text}>
              {customer.name}
            </Label>
          </InfoContainer>
          <InfoContainer>
            <MotoboyIcon color={isEdited || isDeleted ? colors.textLight : colors.text} />
            <Label color={isEdited || isDeleted ? colors.textLight : colors.text}>
              {motoboy.name}
            </Label>
          </InfoContainer>
        </ClientContainer>
      </Line>
      <DescriptionContainer
        color={isEdited || isDeleted ? colors.textLight : colors.text}
      >
        {description}
      </DescriptionContainer>
      <DateContainer color={isEdited || isDeleted ? colors.textLight : colors.text}>
        {dateTimeFormat(new Date(date))}
      </DateContainer>
      <PaymentType
        color={isEdited || isDeleted ? colors.mainBackground : colors.secondary}
        disabled={isDeleted || isEdited}
        value={paymentType}
        onChange={() => null}
        disabledButton
      />
      <CostLabel color={isEdited || isDeleted ? colors.textLight : colors.primary}>
        R$ {maskToPrice(cost.toString()).replace('.', ',')}
      </CostLabel>
    </RowHistoric>
  );

  const GenerateHistoric = (receiptHistoric: IReceipts) => {
    const { historic } = receiptHistoric;

    return (
      <>
        {RowGenerate(receiptHistoric)}
        {historic?.map((e) => RowGenerate(e))}
      </>
    );
  };

  const modal = !isEmpty(editReceipt) && (
    <Container>
      <Backdrop onClick={onDismiss} />
      <ModalContainer aria-modal tabIndex={-1} role="dialog">
        <StyledModal>
          <Header>
            <HeaderText>
              <IconMotoboy />
              Histórico de Corridas
            </HeaderText>
            <CloseButton onClick={onDismiss}>
              <CloseIcon />
            </CloseButton>
          </Header>
          <Content>
            <Body>
              <Column>
                {motoboyDeliveries?.receipts?.map((r) => {
                  return GenerateHistoric(r);
                })}
                <RowHistoric>
                  <LineSpace>
                    <Label>Corridas Faturadas:</Label>
                    <CostLabel color={colors.primary}>
                      R$ {motoboyDeliveries.total_billed}
                    </CostLabel>
                  </LineSpace>
                </RowHistoric>
                <RowHistoric>
                  <LineSpace>
                    <Label>Corridas á Vista:</Label>
                    <CostLabel color={colors.primary}>
                      R$ {motoboyDeliveries.total_cash}
                    </CostLabel>
                  </LineSpace>
                </RowHistoric>
                <RowHistoric>
                  <LineSpace>
                    <Label>Total Bruto:</Label>
                    <CostLabel color={colors.primary}>
                      R$ {motoboyDeliveries.total}
                    </CostLabel>
                  </LineSpace>
                </RowHistoric>
                <RowHistoric>
                  <LineSpace>
                    <Label>Total de Adiantamento:</Label>
                    <CostLabel color={colors.primary}>
                      R$ {motoboyDeliveries.total_pay_advance}
                    </CostLabel>
                  </LineSpace>
                </RowHistoric>
                <RowHistoric>
                  <LineSpace>
                    <Label>Total a pagar p/ o motoboy:</Label>
                    <CostLabel color={colors.primary}>
                      R$ {motoboyDeliveries.total_receivable}
                    </CostLabel>
                  </LineSpace>
                </RowHistoric>
              </Column>
            </Body>
          </Content>
        </StyledModal>
      </ModalContainer>
    </Container>
  );
  return show ? ReactDOM.createPortal(modal, document.body) : null;
};

export default MotoboyDeliveriesHistoricModal;
